import React from 'react';
import { createRoot } from 'react-dom/client';
import App from 'app/App';
import ErrorBoundary from 'features/ErrorBoundary/ErrorBoundary';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
